import { Err } from '@sniptt/monads';
import { getL1RateOrQuote, getPoolDetails, TradeType } from '../../thorchain-utils';
import { SwapperName } from '../../types';
import { assertValidTrade } from './utils';
export const getTradeRate = async (input, deps) => {
    const { sellAsset, buyAsset } = input;
    const assertion = assertValidTrade({ buyAsset, sellAsset });
    if (assertion.isErr())
        return Err(assertion.unwrapErr());
    const poolDetails = await getPoolDetails({
        buyAsset,
        sellAsset,
        url: `${deps.config.VITE_MAYACHAIN_NODE_URL}/mayachain/pools`,
        swapperName: SwapperName.Mayachain,
    });
    if (poolDetails.isErr())
        return Err(poolDetails.unwrapErr());
    const { streamingInterval } = poolDetails.unwrap();
    return getL1RateOrQuote(input, deps, streamingInterval, TradeType.L1ToL1, SwapperName.Mayachain);
};
